'use client';

import { CustomBreadcrumbResponsive } from '@/components/custom-layout/components/custom-breadcrumb';
import { CustomLayoutIconProps } from '@/components/custom-layout/types';
import { pageCustomerDirectories, pageDirectories } from '@/constant/route';
import { SidebarItemProps } from '@/hooks/use-sidebar-store';
import { usePathname } from '@/navigation';
import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';
import { arrHeaderNavbar, arrSidebarNavbar } from '../../common';
import { CustomerNavBar } from '../../type';

type CustomHeaderBreadcrunm = {
    className?: string;
};

function mapCustomNavbarToSidebarItemProps(
    items: CustomerNavBar[],
    numberOfParent: number = 0,
    t: any
): SidebarItemProps[] {
    return items.map(
        (item) =>
            ({
                key: item.id?.toString() ?? item.langResource ?? '',
                id: item.id?.toString(),
                name: t ? t(`Sidebar.${item.langResource}`) : item.langResource,
                href: item.href,
                icon: item.icon
                    ? ({ icon: item.icon } as unknown as CustomLayoutIconProps)
                    : undefined,
                children: item.children
                    ? mapCustomNavbarToSidebarItemProps(
                          item.children,
                          numberOfParent + 1,
                          t
                      )
                    : undefined,
                numberOfParent,
            }) satisfies SidebarItemProps
    );
}

function findSidebarItemWithAncestors(
    items: SidebarItemProps[],
    href: string,
    ancestors: SidebarItemProps[] = []
): SidebarItemProps[] | undefined {
    const toLower = href.toLowerCase();

    for (const item of items) {
        if (item.href && item.href.toLowerCase() === toLower) {
            return [...ancestors, item];
        }
        if (item.children?.length) {
            const found = findSidebarItemWithAncestors(item.children, href, [
                ...ancestors,
                item,
            ]);
            if (found) return found;
        }
    }
    return undefined;
}

export function CustomHeaderBreadcrum(params: CustomHeaderBreadcrunm) {
    const pathname = usePathname();
    const transDef = useTranslations('System');
    const transAll = useTranslations();
    const [items, setItems] = useState<SidebarItemProps[]>([]);

    useEffect(() => {
        const toLower = pathname.toLowerCase();

        const menuForSearch = mapCustomNavbarToSidebarItemProps(
            [...arrHeaderNavbar, ...arrSidebarNavbar],
            undefined,
            transAll
        );

        const filtered = findSidebarItemWithAncestors(menuForSearch, toLower);
        let values: SidebarItemProps[] = [
            {
                name: transDef('System_Home').toUpperCase(),
                key: '-1',
                href: '/',
            },
        ];

        values = createMockupBreadcrum(values, pathname, transAll);

        if (filtered) {
            values.push(...(filtered ?? []));
        }
        setItems(values);
    }, [transDef, pathname, transAll]);

    if (items.length == 0) {
        return <></>;
    }
    return (
        <div className='flex h-full items-center justify-start gap-1 rounded-sm bg-primary/90 pl-3 shadow-sm shadow-primary/20'>
            <CustomBreadcrumbResponsive {...params} items={items} />
        </div>
    );
}

/**
 * Một số breadcrum sẽ mockup ở FE
 */
function createMockupBreadcrum(
    breadcrums: SidebarItemProps[],
    pathname: string,
    t: any
): SidebarItemProps[] {
    let values = [...breadcrums];

    if (pathname.startsWith(pageDirectories['Customer_SubmitDossier'])) {
        values.push({
            name: t('DossierManagement.DossierManagement_DossierDetail'),
            key: '-2',
            href: pathname,
            _showIcon: false,
        });
    }

    if (pathname.includes(pageCustomerDirectories.ProcedureDetail)) {
        values.push({
            name: t('DossierManagement.DossierManagement_Procedure'),
            key: '-2',
        });
    }

    return values;
}
